/**
 * Cálculo de escala dos gráficos, em arquivo separado do componente: exportar
 * funções junto com componentes desativa o fast refresh do Vite.
 */

/**
 * Arredonda o topo do eixo para um número redondo.
 *
 * Um eixo terminando em 37 obriga o leitor a interpolar de cabeça; terminando
 * em 40, cada linha da grade é uma referência que se lê direto.
 */
export function tetoDoEixo(maior: number): number {
  if (maior <= 4) return 4;

  const magnitude = 10 ** Math.floor(Math.log10(maior));
  for (const passo of [1, 2, 2.5, 5]) {
    const candidato = passo * magnitude;
    if (candidato >= maior) return candidato;
  }

  return 10 * magnitude;
}
